<template>
  <div class="product-manage">
    <div class="query-area">
      <el-input
        v-model.trim="keyword"
        style="width: 350px"
        placeholder="请输入编号/内容"
      />
      <el-select
        v-model="status"
        style="width: 140px"
        clearable
        placeholder="选择状态"
        @change="getProductList"
      >
        <el-option
          v-for="v in statusOps"
          :key="v.id"
          :value="v.id"
          :label="v.name"
        />
      </el-select>
      <el-select
        v-model="match"
        style="width: 140px"
        clearable
        placeholder="选择匹配结果"
        @change="getProductList"
      >
        <el-option
          v-for="v in resStatusOps"
          :key="v.id"
          :value="v.id"
          :label="v.name"
        />
      </el-select>
      <el-button
        style="width: 132px; border-color: #2F9EFF; color: #2F9EFF; background: #fff;"
        @click="getProductList"
      >
        查询
      </el-button>
    </div>
    <div class="table-area">
      <el-table
        v-loading="tableLoading"
        border
        :data="tableData"
        header-row-class-name="table-header"
      >
        <el-table-column
          v-for="item in tableColumns"
          :key="item.key"
          :label="item.name"
          :prop="item.key"
          align="center"
          :fixed="item.fixed"
          :min-width="item.minWidth ? item.minWidth : 130"
        >
          <template slot-scope="scope">
            <!-- 产品名 -->
            <span v-if="item.key === 'product_name'">
              <el-tag
                class="tag"
                type="success"
              >
                {{ scope.row.product_name }}
              </el-tag>
            </span>
            <!-- 审核状态 -->
            <span v-else-if="item.key === 'status'">
              <el-tag
                :type="statusDict(scope.row.status).type"
              >
                {{ statusDict(scope.row.status).name || '--' }}
              </el-tag>
            </span>
            <!-- 资质证明 -->
            <span v-else-if="item.key === 'qualification'">
              <span v-if="scope.row.qualification">
                <div
                  v-for="item in scope.row.qualification.split(',')"
                  :key="item"
                  :style="qualificationStyle(item)"
                />
              </span>
            </span>
            <!-- 匹配结果 -->
            <span v-else-if="item.key === 'match_result'">
              <el-tag
                :type="resStatusDict(scope.row.match_result).type"
              >
                {{ resStatusDict(scope.row.match_result).name || '初始' }}
              </el-tag>
            </span>
            <span v-else>
              {{ scope.row[item.key] }}
            </span>
          </template>
        </el-table-column>
        <el-table-column
          label="操作"
          fixed="right"
        >
          <template slot-scope="scope">
            <el-button
              type="text"
              :disabled="scope.row.status === statusDicts.PASS.id"
              @click="handleProduct(scope.row)"
            >
              处理
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        class="pagination"
        :current-page="page"
        :page-sizes="[10, 20, 30, 50, 100]"
        :page-size="page_size"
        layout="total, sizes, prev, pager, next"
        :total="total"
        @size-change="handlePaginationSizeChange"
        @current-change="handlePaginationCurrentChange"
      />
    </div>
    <el-dialog
      :title="dialogTitle"
      :visible.sync="showProductModifyDialog"
      width="650px"
    >
      <el-form
        ref="productForm"
        :model="productForm"
        label-width="130px"
      >
        <el-form-item
          label="产品名称"
          prop="product_name"
        >
          <el-input
            v-model="productForm.product_name"
            disabled
            type="text"
            style="width: 400px;"
          />
        </el-form-item>
        <el-form-item
          label="应用市场链接"
          prop="product_url"
        >
          <el-input
            v-model="productForm.product_url"
            disabled
            style="width: 400px;"
          />
        </el-form-item>
        <el-form-item
          label="公司名称"
          prop="product_company"
        >
          <el-input
            v-model="productForm.product_company"
            disabled
            style="width: 400px;"
          />
        </el-form-item>
        <el-form-item
          v-if="productForm.qualification"
          label="资质证明"
          prop="qualification"
        >
          <image-viewer :images="productForm.qualification.split(',')" />
        </el-form-item>
        <el-form-item
          v-if="showReason"
          label="驳回理由"
          prop="reason"
        >
          <el-input
            v-model="productForm.reason"
            type="textarea"
            style="width: 400px;"
          />
        </el-form-item>
      </el-form>
      <div
        slot="footer"
        class="dialog-footer"
      >
        <el-button
          type="primary"
          @click="handleConfirm"
        >
          {{ confirmText }}
        </el-button>
        <el-button @click="handleReject">{{ cancelText }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Request from '@/core/QuRequest';
import ImageViewer from '@/components/ImageViewer';

const req = new Request();
const query = (dict) => {
  const _dict = Object.values(dict).reduce((r, v) => {
    r[v.id] = v;
    return r;
  }, {});
  return (id) => _dict[id] || {};
};
const STATUS = {
  WAIT: { id: 1, name: '待审核', type: 'danger' },
  PASS: { id: 2, name: '审核通过', type: 'success' },
  REJECT: { id: 3, name: '审核拒绝', type: 'danger' },
};
const RESULT_STATUS = {
  MATCH: { id: 1, name: '匹配', type: 'danger' },
  DISMATCH: { id: 2, name: '未匹配', type: 'success' },
};

export default {
  name: 'operationProductManage',
  components: {
    ImageViewer,
  },
  data() {
    return {
      // dict
      statusDicts: STATUS,
      statusDict: query(STATUS),
      statusOps: Object.values(STATUS),
      resStatusDict: query(RESULT_STATUS),
      resStatusOps: Object.values(RESULT_STATUS),

      keyword: '',
      status: '',
      match: '',
      tableLoading: false,
      tableData: [],
      tableColumns: [
        {
          key: 'id',
          name: '编号',
          fixed: true,
          minWidth: 80,
        },
        {
          key: 'product_name',
          name: '产品名称',
          fixed: true,
        },
        {
          key: 'product_url',
          name: '产品链接',
          minWidth: 300,
        },
        {
          key: 'product_company',
          name: '广告主公司名称',
        },
        {
          key: 'qualification',
          name: '资质证明',
          minWidth: 205,
        },
        {
          key: 'create_time',
          name: '申请时间',
          minWidth: 160,
        },
        {
          key: 'user_name',
          name: '申请人',
        },
        {
          key: 'operator',
          name: '处理人',
        },
        {
          key: 'reason',
          name: '修改意见',
          minWidth: 180,
        },
        {
          key: 'status',
          name: '状态',
        },
        {
          key: 'match_result',
          name: '匹配结果',
        },
      ],
      page: 1,
      page_size: 10,
      total: 0,
      showProductModifyDialog: false,
      productForm: {
        product_name: '',
        product_url: '',
        product_company: '',
        qualification: '',
        reason: '',
      },
      targetItem: {},
      dialogTitle: '',
      showReason: false,
      confirmText: '通过',
      cancelText: '驳回',
    };
  },
  created() {
    this.getProductList();
  },
  methods: {
    async getProductList() {
      try {
        this.tableLoading = true;
        let params = {
          keyword: this.keyword,
          status: this.status,
          match: this.match,
          page: this.page,
          page_size: this.page_size,
        };
        const res = await req.send(
          req.Apis.sales.agent.productAdminList,
          params,
        );
        this.tableData = res.data.list;
        this.total = Number(res.data.total);
        this.tableLoading = false;
      } catch (err) {
        this.tableLoading = false;
        this.$message.error(`获取产品列表失败：${err.message || '未知错误'}`);
      }
    },
    handleProduct(item) {
      this.targetItem = item;
      let result = this.resStatusDict(item.match_result).name || '初始';
      this.dialogTitle = `匹配结果为【${result}】，请确认审核状态`;
      this.productForm.product_name = item.product_name;
      this.productForm.product_url = item.product_url;
      this.productForm.product_company = item.product_company;
      this.productForm.qualification = item.qualification;
      this.productForm.reason = '';
      this.showReason = false;
      this.confirmText = '通过';
      this.cancelText = '驳回';
      this.showProductModifyDialog = true;
    },
    handleReject() {
      this.showReason = !this.showReason;
      this.confirmText = this.showReason ? '提交' : '通过';
      this.cancelText = this.showReason ? '取消' : '驳回';
    },
    async handleConfirm() {
      if (this.showReason && !this.productForm.reason) return;
      try {
        let params = {
          id: this.targetItem.id,
          result: this.showReason ? 0 : 1,
          reason: this.productForm.reason,
        };
        await req.send(req.Apis.sales.agent.productReview, params);
        this.showProductModifyDialog = false;
        this.$message.success('审批完成');
        this.getProductList();
      } catch (err) {
        this.$message.error(`审批失败：${err.message || '未知错误'}`);
      }
    },
    handlePaginationSizeChange(size) {
      this.page_size = size;
      this.getProductList();
    },
    handlePaginationCurrentChange(current) {
      this.page = current;
      this.getProductList();
    },
    // 返回列表中资质图片的样式
    qualificationStyle(url) {
      return {
        background: `url(${url}) no-repeat center center /cover`,
        display: 'inline-block',
        width: '50px',
        height: '50px',
        'margin-right': '5px',
        'margin-left': '5px',
        'box-shadow':
          '0px 0px 8px 0px rgba(32, 45, 112, 0.1), 0px 0px 2px 0px rgba(32, 45, 112, 0.04)',
      };
    },
  },
};
</script>
<style lang="less" scoped>
.product-manage {
  .query-area {
    margin: 24px 0;
    .el-input,
    .el-select {
      margin-right: 24px;
    }
  }
  .pagination {
    float: right;
    margin-top: 20px;
  }
  .is-disabled {
    /deep/ input {
      background: transparent;
      color: rgb(96, 98, 102);
    }
  }
  .value {
    font-size: 14px;
    font-weight: 500;
    color: rgba(48, 49, 51, 1);

    .preview-img {
      display: inline-block;
      margin: 0 24px 24px 0;
      position: relative;
      width: 200px;
      height: 200px;
      overflow: hidden;
      border: 1px solid #ddd;

      &:hover {
        .view-btn,
        &::before {
          display: block;
        }
      }

      &::before {
        display: none;
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        z-index: 2;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.2);
      }

      .view-btn {
        display: none;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        z-index: 3;
        color: #fff;
        font-size: 30px;

        .view-mask-img {
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          z-index: 2;
          width: 100%;
          opacity: 0;
        }
      }

      .view-img {
        position: absolute;
        top: 0;
        width: 100%;
        left: 0;
      }
    }
  }
}
</style>
